import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';
import { type FC } from 'react';
import { useTheme } from 'next-themes';

import { cn } from '@/lib/utils';

interface MarkdownReaderProps {
  content: string;
}

export const MarkdownReader: FC<MarkdownReaderProps> = ({ content }) => {
  const { resolvedTheme } = useTheme();
  const baseClasses =
    'prose prose-sm max-w-none prose-headings:m-0 prose-headings:underline prose-hr:m-1 prose-p:m-0';

  return (
    <div className={cn(baseClasses, resolvedTheme === 'dark' && 'prose-invert')}>
      <Markdown remarkPlugins={[remarkGfm]}>{content.replace(/<br \/>/g, '&nbsp;  ')}</Markdown>
    </div>
  );
};
